module.exports = __webpack_public_path__ + "img/sideicon2.87ce6cbe.png";